import * as React from "react";
import type { SVGProps } from "react";
const SvgTrustly = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path fill="#000" d="M8.67 13.38v-2.7H7.7v-.64h2.64v.64h-.97v2.7z" />
    <path
      fill="#000"
      d="M10.23 13.38v-2.42h.64v.38c.15-.32.35-.38.56-.38h.24v.65h-.2c-.3 0-.58.17-.58.7v1.07zm1.75-.88v-1.54h.66v1.38c0 .29.14.5.42.5s.45-.21.45-.5v-1.38h.66v2.42h-.63v-.3a.8.8 0 0 1-.7.36c-.53 0-.86-.37-.86-.95m2.48.21.58-.13c.02.18.17.33.46.33.23 0 .35-.1.35-.2s-.05-.17-.28-.22l-.38-.08q-.7-.14-.69-.74c0-.41.34-.75.99-.75.69 0 .96.41.99.68l-.58.13c-.03-.14-.13-.3-.42-.3q-.3.02-.32.2 0 .15.18.19l.56.13q.63.15.62.7c0 .38-.31.79-1.01.79-.77 0-1.03-.47-1.05-.73m3.34.68c-.44 0-.73-.24-.73-.7v-1.14h-.4v-.58h.4v-.54l.67-.2v.74h.49v.58h-.5v1.01q0 .26.28.25h.25v.58zm.82 0v-3.33h.67v3.33zm2.67-2.42H22l-1.01 3.29h-.71l.28-.87h-.37l-.67-2.42h.71l.5 1.87zM2 11.5h1.56v-1.24l1.24 1.25-1.24 1.23v.64h1.5V11.5h1.4v-1.46H2z"
    />
  </svg>
);
export default SvgTrustly;
